/* unplugin-vue-components disabled */import { render } from "./Songs.vue?vue&type=template&id=9ff48564&ts=true"
import script from "./Songs.vue?vue&type=script&lang=ts"
export * from "./Songs.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Song\\Demo\\hxswmj\\hxswmj_vue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__